var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('el-empty',{attrs:{"image-size":500,"description":"找不到该页面，请返回"}},[_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":_vm.back}},[_vm._v("返回")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }